(function(){
  if(window.__phHomeMainInitialized)return;
  window.__phHomeMainInitialized=true;

  window.phHomeHeroShow=function(hero,index){
    const slides=hero.querySelectorAll('[data-ph-hero-slide]');
    const dots=hero.querySelectorAll('[data-ph-hero-dot]');
    if(!slides.length)return;
    const next=(index+slides.length)%slides.length;
    slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===next);});
    dots.forEach(function(dot,i){
      const active=i===next;
      dot.classList.toggle('is-active',active);
      dot.setAttribute('aria-current',active?'true':'false');
    });
    hero.dataset.phHeroIndex=String(next);
  };

  window.phArticleRender=function(page){
    const active=page.dataset.articleFilter||'all';
    const limit=Number(page.dataset.articleVisible||10);
    const cards=Array.prototype.slice.call(page.querySelectorAll('[data-category]'));
    const useLimit=active==='all';
    let shown=0;
    let total=0;
    cards.forEach(function(card){
      const matches=active==='all'||card.dataset.category===active;
      if(matches)total+=1;
      const visible=matches&&(!useLimit||shown<limit);
      if(visible)shown+=1;
      card.classList.toggle('is-hidden',!visible);
    });
    const button=page.querySelector('[data-load-more]');
    if(button)button.hidden=shown>=total;
  };

  function initHero(hero){
    if(!hero||hero.dataset.phHeroReady==='true')return;
    hero.dataset.phHeroReady='true';
    hero.dataset.phHeroIndex=hero.dataset.phHeroIndex||'0';
    const slides=hero.querySelectorAll('[data-ph-hero-slide]');
    if(slides.length<2||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    window.setInterval(function(){
      if(document.hidden||hero.matches(':hover'))return;
      const current=Number(hero.dataset.phHeroIndex||0);
      window.phHomeHeroShow(hero,current+1);
    },6000);
  }

  function initArticleList(page){
    if(!page||page.dataset.phArticleReady==='true')return;
    page.dataset.phArticleReady='true';
    page.dataset.articleFilter='all';
    page.dataset.articleVisible='10';
    window.phArticleRender(page);
  }

  function initScope(scope){
    (scope.matches&&scope.matches('[data-ph-hero]')?[scope]:scope.querySelectorAll('[data-ph-hero]')).forEach(initHero);
    (scope.matches&&scope.matches('[data-article-list]')?[scope]:scope.querySelectorAll('[data-article-list]')).forEach(initArticleList);
  }

  document.addEventListener('click',function(e){
    const tab=e.target.closest('[data-ph-tab]');
    if(tab){
      const section=tab.closest('[data-ph-news]');
      if(!section)return;
      const category=tab.dataset.phTab;
      section.querySelectorAll('[data-ph-tab]').forEach(function(item){
        const active=item===tab;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-selected',active?'true':'false');
      });
      section.querySelectorAll('[data-ph-category]').forEach(function(card){
        card.hidden=category!=='all'&&card.dataset.phCategory!==category;
      });
      return;
    }

    const dot=e.target.closest('[data-ph-hero-dot]');
    if(dot){
      const hero=dot.closest('[data-ph-hero]');
      if(hero)window.phHomeHeroShow(hero,Number(dot.dataset.phHeroDot||0));
      return;
    }

    const heroPrev=e.target.closest('[data-ph-hero-prev]');
    const heroNext=e.target.closest('[data-ph-hero-next]');
    if(heroPrev||heroNext){
      const hero=(heroPrev||heroNext).closest('[data-ph-hero]');
      if(hero){
        const current=Number(hero.dataset.phHeroIndex||0);
        window.phHomeHeroShow(hero,current+(heroPrev?-1:1));
      }
      return;
    }

    const filter=e.target.closest('[data-article-filter]');
    if(filter){
      const page=filter.closest('[data-article-list]');
      if(!page)return;
      const category=filter.dataset.articleFilter;
      page.dataset.articleFilter=category;
      page.dataset.articleVisible='10';
      page.querySelectorAll('[data-article-filter]').forEach(function(item){
        item.classList.toggle('is-active',item===filter);
      });
      window.phArticleRender(page);
      return;
    }

    const loadMore=e.target.closest('[data-load-more]');
    if(loadMore){
      const page=loadMore.closest('[data-article-list]');
      if(!page)return;
      page.dataset.articleVisible=String(Number(page.dataset.articleVisible||10)+10);
      window.phArticleRender(page);
      return;
    }

    const playButton=e.target.closest('[data-ph-youtube-play]');
    if(playButton){
      const player=playButton.closest('[data-ph-local-video]');
      if(!player||player.classList.contains('is-playing'))return;
      const video=player.querySelector('[data-ph-local-video-media]');
      if(!video)return;
      player.classList.add('is-playing');
      playButton.hidden=true;
      video.hidden=false;
      video.currentTime=0;
      const playPromise=video.play();
      if(playPromise&&typeof playPromise.catch==='function'){
        playPromise.catch(function(){video.controls=true;});
      }
    }
  });

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initScope(document);},{once:true});
  }else{
    initScope(document);
  }

  document.addEventListener('shopify:section:load',function(event){initScope(event.target);});
})();
